import { Box } from '@ovComponents/1-primative/box/box';
import { Typography } from '@ovComponents/1-primative/typography/typography';
import type { FC } from 'react';
import { WATCH_LIST_COPY } from './watchListCopy';

/**
 * Minimal empty state shown when no accounts are approaching threshold.
 * Per AC #5: a low-key one-liner — no success icon, minimal height.
 */
export const WatchListEmptyState: FC = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        py: 1,
      }}
    >
      <Typography variant='bodyMedium' colorVariant='variant'>
        {WATCH_LIST_COPY.empty.title}
      </Typography>
    </Box>
  );
};
